function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatasetHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0.915891
    },
    fill: "#fff",
    d: "M7.515 23.78s7.382-10.113 16.49-10.113c9.108 0 16.482 10.112 16.482 10.112s-7.373 10.038-16.482 10.038c-9.108 0-16.49-10.038-16.49-10.038z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0.915891
    },
    fill: "#cfd8dc",
    d: "M24.005 13.667c9.109 0 16.482 10.112 16.482 10.112s-7.373 10.038-16.482 10.038c-9.108 0-16.49-10.038-16.49-10.038s7.382-10.112 16.49-10.112m0-1.832c-9.925 0-17.646 10.42-17.97 10.864l-.791 1.085.795 1.08c.324.441 8.045 10.784 17.966 10.784 9.922 0 17.635-10.344 17.958-10.783l.794-1.081-.79-1.084c-.324-.444-8.036-10.865-17.962-10.865Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0.915891,
      fill: "#b3e0e5",
      fillOpacity: 1
    },
    fill: "#00acc1",
    d: "M15.763 23.736c0-4.553 3.695-8.237 8.243-8.237 4.55 0 8.243 3.684 8.243 8.237a8.245 8.245 0 0 1-8.243 8.249 8.246 8.246 0 0 1-8.243-8.249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0.915891,
      fill: "#40babf",
      fillOpacity: 1
    },
    fill: "#006064",
    d: "M20.342 23.74a3.664 3.664 0 1 1 3.664 3.664 3.655 3.655 0 0 1-3.664-3.663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0.915891
    },
    fill: "#90a4ae",
    d: "M7.542 23.742c.48-.641 7.665-10.038 16.463-10.038 8.797 0 15.975 9.396 16.455 10.037H45l-1.556-2.126c-.347-.473-8.598-11.575-19.439-11.575S4.906 21.14 4.56 21.613L3 23.742Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 41.166 41.166 44 4 6.834 6.834 4Z",
    fill: "#37474f",
    style: {
      strokeWidth: 1.00001
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatasetHide);
export default __webpack_public_path__ + "static/media/datasetHide.fe29cfca7101c717af2a0b9adc7e67ef.svg";
export { ForwardRef as ReactComponent };